'use client';

import { useEffect } from 'react';
import { onConsentChange, readConsent } from '@owlcat/app-shell/consent';
import { ConsentManager } from '@/contexts/application/consent/consentManager';

/**
 * Fleet ↔ portal consent bridge (ONE-WAY: shared cookie → portal ConsentManager).
 *
 * The single, fleet-wide banner (@owlcat/app-shell <CookieConsent>) is now the
 * source of truth for FIRST consent — it writes the parent-domain `owlcat-consent`
 * cookie every sibling app reads. Portal still runs its ConsentManager (which
 * gates PostHog and backs the granular preference-center modal), so we mirror the
 * shared choice INTO the manager on mount and on every shared change, keeping
 * analytics/functional gating in agreement with the fleet cookie without
 * duplicating the banner UI.
 *
 * Only the fleet-aligned categories cross the bridge (functional, analytics).
 * The old `marketing` category (Tawk.to live chat) was removed — support is now a
 * first-party contact form (<SupportWidget> → accounts /support) that sets no
 * third-party cookies, so there is no marketing consent to gate.
 */
export function ConsentBridge() {
  useEffect(() => {
    const sync = () => {
      const rec = readConsent();
      if (!rec) return; // no shared choice yet → leave portal state untouched
      ConsentManager.getInstance().updateConsent({
        functional: rec.categories.functional === true,
        analytics: rec.categories.analytics === true,
      });
    };
    sync();
    return onConsentChange(sync);
  }, []);
  return null;
}
